<template>
  <div class="join-status" v-if="data">
    <div class="scratch-card" v-if="[2, 3].includes(data.prize_state)">
      <scratch-card
        ref="scratchCard"
        :speed="36"
        :allow="false"
        :showResult="showResult"
        :c_width="sizeBox.width"
        :imgUrl="imageUrl"
        :c_height="sizeBox.height"
        :cricle_size="50"
        :c_color="cover"
        :percent="80"
        @SuccessFunc="scratchSuccess"
      >
        <div>
          <div class="result-container" v-if="data.prize_state == 3">
            <div class="title">恭喜你，中奖啦！</div>
            <div class="gift-container">
              <img
                class="gift-image"
                :src="data.data.current_user_award.prize_banner"
                alt=""
              />
              <div class="gift-info">
                <div class="gift-name"
                  >{{ data.data.current_user_award.prize_name }}*{{
                    data.data.current_user_award.num
                  }}</div
                >
                <div class="gift-desc">
                  <span v-if="data.data.current_user_award.act_prize_level == 1"
                    >奖品款式/颜色随机发放<br />于活动结束后7个工作日内邮寄</span
                  >
                  <span v-else
                    >奖品款式/颜色随机发放<br />请前往主责门店，展示本页面领取</span
                  >
                </div>
                <div
                  class="gift-address"
                  v-if="data.data.current_user_award.act_prize_level == 1"
                  @click="bindFillAddress"
                  >{{ addressData.id ? '查看收货地址' : '填写收货地址' }}</div
                >
                <div class="gift-address" v-else @click="bindToMyPrize"
                  >查看我的奖品</div
                >
              </div>
            </div>
            <div class="time-container"
              ><span class="iconfont icon-duigouxiao"></span
              ><span class="time-flex">{{
                data.data.course_info.shop_name
              }}</span>
              <span class="coach-name"
                >{{ data.data.course_info.coach_name }}教练</span
              >
              <span>{{ data.data.course_info.start_desc }}</span></div
            >
          </div>
          <!-- 已参与 未中奖 -->
          <div class="status-container status2" v-if="data.prize_state == 2">
            <div class="title">很遗憾，未中奖</div>
            <div class="desc">上课时间未在中奖时段，再约一节课试试运气吧～</div>
            <div class="time-container"
              ><span class="iconfont icon-duigouxiao"></span>
              <span class="time-flex">{{
                data.data.course_info.shop_name
              }}</span>
              <span class="coach-name"
                >{{ data.data.course_info.coach_name }}教练</span
              >
              <span>{{ data.data.course_info.start_desc }}</span></div
            >
            <div class="btn" @click="bindToReservation">去约课</div>
            <div class="app-tips">使用app约课获得更多经验值</div>
          </div>
        </div>
      </scratch-card>
    </div>
    <!-- 已参与 未开奖 -->
    <div
      class="status-container status1"
      v-if="data.is_participate == 2 && data.prize_state == 1"
    >
      <div class="title"
        ><span class="gou iconfont icon-gou"></span><span>参与成功</span></div
      >
      <div class="desc"
        ><span class="bold"
          >次日{{ data.data.act_info.easter_egg_pub_time | filterHours }}</span
        >公布中奖时段，<br />
        未上课将失去参与资格哦～</div
      >
      <div class="time-container" v-if="data.data.course_info"
        ><span class="iconfont icon-shijian"></span
        ><span class="time-flex">{{ data.data.course_info.shop_name }}</span>
        <span class="coach-name"
          >{{ data.data.course_info.coach_name }}教练</span
        >
        <span>{{ data.data.course_info.start_desc }}</span></div
      >
      <div class="app-tips">使用app约课获得更多经验值</div>
    </div>
    <!-- 未参与  已过期 -->
    <div
      class="status-container status3"
      v-if="data.is_participate == 1 && data.prize_state == 0"
    >
      <div class="title">当日报名已结束</div>
      <div class="desc">预约课程，参与最新抽奖</div>
      <div class="btn" @click="bindToReservation">去约课</div>
    </div>
    <!-- 未参与 未开奖 -->
    <div
      class="status-container status4"
      v-if="data.is_participate == 1 && data.prize_state == 1"
    >
      <div class="title" v-if="isApp">还未参与活动</div>
      <div class="desc" :class="{ 'share-desc': !isApp }">{{
        isApp ? '上课打卡即有可能获得惊喜大奖' : '上课打卡抽惊喜大奖'
      }}</div>
      <div class="btn" @click="bindToReservation">{{
        isApp ? '去约课' : '去APP参与活动'
      }}</div>
      <div class="app-tips">使用app约课获得更多经验值</div>
    </div>
  </div>
</template>

<script>
import ScratchCard from './scratch-card.vue'
export default {
  components: { ScratchCard },
  props: {
    data: {
      type: Object,
      default: null
    },
    addressData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showCard: true,
      showResult: false,
      cover: '#c5c5c5',
      isApp: true,
      imageUrl:
        'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/c37c4be77d1c8f16c3f3bcd6a07f31ef_wh=993_636.png'
    }
  },
  filters: {
    filterHours(str) {
      return str.slice(0, 5)
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setShowResult()
        this.$nextTick(() => {
          this.allowDragCard()
        })
      }
    }
  },
  computed: {
    sizeBox() {
      return {
        width: 331,
        height: 212
      }
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    this.setShowResult()
  },
  mounted() {
    this.allowDragCard()
  },
  methods: {
    setShowResult() {
      let localData = localStorage.getItem(
        'springCourseReservation2025-' + this.data.date
      )
      this.showResult = !!localData
    },
    allowDragCard() {
      if (!this.showResult && [2, 3].includes(this.data.prize_state)) {
        this.$refs.scratchCard.auto()
        localStorage.setItem(
          'springCourseReservation2025-' + this.data.date,
          true
        )
      }
    },
    scratchSuccess() {
      this.showCard = false
    },
    bindFillAddress() {
      this.$emit('address')
    },
    bindToMyPrize() {
      this.$emit('prize')
    },
    bindToReservation() {
      this.$emit('appointment')
    }
  }
}
</script>
<style lang="scss" scoped>
.join-status {
  background-color: #fff;
  border-radius: 6px 6px 8px 8px;
  padding: 14px 10px 16px;
  .result-container {
    height: 212px;
    box-sizing: border-box;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/e94d48b3db1a261b8884455b64800491_wh=1324_848.png');
    background-repeat: no-repeat;
    background-size: contain;

    .title {
      font-weight: bold;
      font-size: 22px;
      color: #f31b27;
      line-height: 30px;
      margin-bottom: 4px;
    }
    .time-container {
      height: auto;
      .iconfont {
        font-size: 12px;
      }
    }
    .gift-container {
      width: 280px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(231, 170, 86, 0.22);
      border-radius: 6px;
      padding: 3px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .gift-image {
        width: 100px;
        height: 100px;
        object-fit: contain;
        margin-right: 11px;
      }
      .gift-info {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .gift-name {
          font-weight: bold;
          font-size: 13px;
          color: #000000;
          line-height: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-bottom: 5px;
        }
        .gift-desc {
          font-size: 10px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 13px;
          margin-bottom: 9px;
        }
        .gift-address {
          width: 112px;
          height: 28px;
          background: #f31b27;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
  .scratch-card {
    border-radius: 8px;
    overflow: hidden;
  }
  .app-tips {
    font-size: 10px;
    color: rgba(0, 0, 0, 0.6);
  }
  .status-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 212px;
    background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/c37c4be77d1c8f16c3f3bcd6a07f31ef_wh=993_636.png');
    background-repeat: no-repeat;
    background-size: 100%;
    .title {
      font-weight: bold;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 30px;
      margin-bottom: 4px;
    }
    .desc {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 22px;
      margin-bottom: 22px;
      .bold {
        color: #000;
      }
    }
    .time-container {
      background: rgba(255, 255, 255, 0.6);
      border-radius: 14px;
      .iconfont {
        font-size: 16px;
        font-weight: normal;
        color: rgb(127, 127, 127);
      }
    }
    .btn {
      margin-top: 12px;
      width: 231px;
      height: 61px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 19px;
      color: #ffffff;
      line-height: 25px;
      text-shadow: 0px 2px 4px rgba(210, 96, 115, 0.33);
      background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/013e8fcf1638016205f500e515217a4d_wh=693_183.png');
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
  .status1 {
    padding-top: 6px;
    .app-tips {
      margin-top: 27px;
    }
    .desc {
      margin-bottom: 20px;
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      .gou {
        width: 25px;
        height: 25px;
        background: #ff2270;
        border-radius: 50%;
        margin-right: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 12px;
      }
    }
  }
  .status2 {
    .desc {
      margin-bottom: 10px;
    }
    .time-container {
      .iconfont {
        font-size: 13px;
      }
    }
  }
  .status3,
  .status4 {
    padding-top: 18px;
    .desc {
      margin-bottom: 0px;
    }
  }
  .status4 {
    .share-desc {
      font-weight: bold;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 30px;
    }
  }
  .time-container {
    max-width: 95%;
    font-weight: bold;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    padding: 0px 10px;
    box-sizing: border-box;
    height: 27px;
    display: flex;
    align-items: center;
    .time-flex {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 4px;
    }
    .coach-name {
      margin-right: 3px;
    }
    .iconfont {
      color: rgb(154, 133, 110);
      margin-right: 3px;
      font-size: 13px;
    }
  }
}
</style>
